import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=01c032ee&scoped=true"
import script from "./AliPlayer.vue?vue&type=script&lang=js"
export * from "./AliPlayer.vue?vue&type=script&lang=js"
import style0 from "./AliPlayer.vue?vue&type=style&index=0&id=01c032ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c032ee",
  null
  
)

export default component.exports